import {Pipe, PipeTransform} from '@angular/core';
import {MoneyService} from '@services/money/money.service';

@Pipe({
  name: 'convertIntoDollars'
})
export class ConvertIntoDollarsPipe implements PipeTransform {
  constructor(private moneyService: MoneyService) {
  }

  transform(value: number): number {
    if (!value) return 0;
    return this.moneyService.convertIntoDollars(value);
  }
}
